import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import Modal from '@ublique/components/LoadingModal'

const ModalScenarioReset = ({
  open,
  close,
  data: { onDownloadFile, onUpdate }
}) => {
  const { t } = useTranslation('Scenario')

  const onSubmit = useCallback(async () => {
    await onDownloadFile()
    onUpdate()
    close()
  }, [onDownloadFile, onUpdate, close])

  const onRequestClose = useCallback(() => {
    onUpdate()
    close()
  }, [onUpdate, close])

  return (
    <Modal
      open={open}
      size='sm'
      iconDescription={t('close')}
      modalHeading={t('MODAL_DOWNLOAD_ERROR_TITLE')}
      onRequestClose={onRequestClose}
      onRequestSubmit={onSubmit}
      onSecondarySubmit={onRequestClose}
      primaryButtonText={t('Download')}
      secondaryButtonText={t('Cancel')}
      preventCloseOnClickOutside
    >
      <p>{t('MODAL_BODY_DOWNLOAD_REQUEST')}</p>
    </Modal>
  )
}

export default React.memo(ModalScenarioReset)
